import { ventajas } from './mock/ventajasData.js';


angular.module('Toke').factory('ventajasRepository', function ($q) {

    function getVentajas() {
        return $q.resolve(ventajas)
    }

    // para lista futura
    // function getVentajasFromList() {

    //     const listUrl =
    //         baseUrl +
    //         "/_api/web/lists/getbytitle('Ventajas')/items" +
    //         "?$select=Title,Url,ParentId,Order,IsActive" +
    //         "&$orderby=Order asc";

    //     return $http({
    //         method: 'GET',
    //         url: listUrl,
    //         headers: {
    //             Accept: 'application/json;odata=nometadata'
    //         }
    //     }).then(function (response) {
    //         return response.data.value;
    //     });
    // }



    return {
        getVentajas: getVentajas
    };

});

